import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { AdrDto, SuitCounselDto, CounselTypeDto } from '@cradua/data';

@Component({
  selector: 'cradua-adrcounsel',
  templateUrl: './adrcounsel.component.html',
  styleUrls: ['./adrcounsel.component.scss']
})

export class AdrcounselComponent implements OnInit { 
  
@Input() selectedSuitProgresss: AdrDto;
@Input() counseltypes: CounselTypeDto[];

  suitcounselForm: FormGroup;
  filteredSuitCounsel: any = [];
  filteredCounselType: any = [];

  filteredDelete = [];
  mysubscription: any;
  status: boolean;
  counseltypeId: string;
  isToggle = false;
  listView = false;
  gridView = true;
  hidelist: boolean;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.suitcounselForm = this.fb.group({
      SuitCounsels: this.fb.array([])
    });
  }

  searchCounselType(event) {
    const name = event.toLowerCase();
    if (name) {
      this.filteredCounselType = this.counseltypes.filter(p =>
        p.CounselTypeName.toLowerCase().includes(name));
    } else {
    this.filteredCounselType = this.counseltypes;
    }
    this.hidelist = true;
  }

  selectCounselType(id: string) {
    this.counseltypeId = id;
    // this.filteredSuitCounsel = this.selectedSuitProgresss.suitCounsels.filter(c => c.CounselTypeId.toLowerCase() === id.toLowerCase());
    this.status = true;
    this.hidelist = false;
  }
  
  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }
  
}
